module.exports = __webpack_public_path__ + "static/paris-020.thumb-d50f2eb7d8b202b1b692dff06d457e17.jpg";